export default __webpack_public_path__ + "52db6e6462a2cf97ef5ad5db9ff2b7cb.woff";